
import quinta1 from "../assets/images/barriosImagenes/quinta-seccion/aristides-villanueva.jpg.webp"
import quinta2 from "../assets/images/barriosImagenes/quinta-seccion/metro-tranvia.jpg"
import quinta3 from "../assets/images/barriosImagenes/quinta-seccion/parque-paseo.webp"
import palmaresMall from "../assets/images/barriosImagenes/palmares/palmares-mall.jpg"


export const barriosPorDepartamento = {
  capital: [
    {
      id: 'centro',
      name: 'Centro',
      department: 'capital',
      description: '',
      highlights: [],
      photos: [],
      tags: ['urbano', 'comercial'],
      center: { lat: -32.8894, lng: -68.8458 }
    },
   {
  id: 'quinta_seccion_residencial_sur',
  name: 'Quinta Sección',
  department: 'capital',

  description:
    'La Quinta Sección es una de las zonas residenciales más valoradas de la Ciudad de Mendoza. Se caracteriza por sus calles arboladas, cercanía al Parque General San Martín y una oferta gastronómica y cultural consolidada.La Quinta Sección de la Ciudad de Mendoza es reconocida por su equilibrio entre tradición y modernidad, caracterizada por ser una zona residencial arbolada que ha experimentado un notable desarrollo inmobiliario vertical en los últimos años. Se destaca por su excelente calidad de vida, su cercanía a puntos clave de la ciudad y su ambiente tranquilo pero con servicios completos. ',

  highlights: [
    'Cercanía al Parque General San Martín',
    'Zona residencial premium',
    'Cafés y restaurantes de autor',
    'Cercania a universidades y centros culturales',
    'Cercania a gimnasios y clubes deportivos',
    'Cercania a gimnasios y clubes deportivos',
    'Excelente conectividad con el centro'
  ],

  photos: [
    quinta1,
    quinta2,
    quinta3
  ],

  tags: ['premium', 'residencial', 'verde'],

  center: { lat: -32.8899, lng: -68.8574 }
},
   {
  id: 'sexta_seccion',
  name: 'Sexta Sección',
  department: 'capital',
  description:
    'Zona residencial tranquila de la Ciudad de Mendoza, con buena conectividad y cercanía al centro. Predominan viviendas familiares y pequeños edificios.',
  highlights: [
    'Ambiente residencial',
    'Buena conectividad',
    'Cercanía al centro'
  ],
  photos: [],
  tags: ['residencial', 'tranquilo'],
  center: { lat: -32.9031, lng: -68.8402 }
},
{
  id: 'primera_seccion',
  name: 'Primera Sección',
  department: 'capital',
  description:
    'Área céntrica de Mendoza con fuerte presencia comercial, administrativa y cultural. Ideal para quienes buscan cercanía a servicios y transporte.',
  highlights: [
    'Zona céntrica',
    'Amplia oferta comercial',
    'Transporte público cercano'
  ],
  photos: [],
  tags: ['urbano', 'comercial'],
  center: { lat: -32.8894, lng: -68.8458 }
},
    {
      id: 'cuarta_oeste',
      name: 'Cuarta Oeste',
      department: 'capital',
      description: '',
      highlights: [],
      photos: [],
      tags: ['tradicional'],
      center: { lat: -32.8805, lng: -68.8652 }
    }
  ],

  godoy_cruz: [
    {
  id: 'bombal',
  name: 'Bombal',
  department: 'godoy_cruz',
  description:
    'Barrio tradicional y residencial, muy valorado por su cercanía al centro de Mendoza y su perfil tranquilo.',
  highlights: [
    'Zona residencial tradicional',
    'Cercanía al centro',
    'Calles arboladas'
  ],
  photos: [],
  tags: ['residencial', 'tradicional'],
  center: { lat: -32.9083, lng: -68.8516 }
},

{
  id: 'palmares',
  name: 'Palmares',
  department: 'godoy_cruz',
  description:
    'Zona moderna con desarrollo comercial, residencial y gastronómico, reconocida por su shopping y barrios privados.',
  highlights: [
    'Zona moderna',
    'Oferta gastronómica',
    'Shopping Palmares'
  ],
  photos: [palmaresMall],
  tags: ['premium', 'moderno'],
  center: { lat: -32.9504, lng: -68.8523 }
},
{id: 'dorrego', name: 'Dorrego', department: 'godoy_cruz', description: 'Zona urbana integrada al área metropolitana, con accesos a servicios y corredores comerciales cercanos.', highlights: ['Conexión con el Gran Mendoza', 'Servicios de cercanía'], photos: [], tags: ['residencial'], center: { lat: -32.9038, lng: -68.8049 }},
  ],

  guaymallen: [
    {
      id: 'dorrego',
      name: 'Dorrego',
      department: 'guaymallen',
      description: '',
      highlights: [],
      photos: [],
      tags: ['residencial'],
      center: { lat: -32.9038, lng: -68.8049 }
    },
    {
      id: 'villa_nueva',
      name: 'Villa Nueva',
      department: 'guaymallen',
      description: '',
      highlights: [],
      photos: [],
      tags: ['urbano'],
      center: { lat: -32.8964, lng: -68.8246 }
    },
    {
      id: 'san_jose',
      name: 'San José',
      department: 'guaymallen',
      description: '',
      highlights: [],
      photos: [],
      tags: ['tradicional'],
      center: { lat: -32.8898, lng: -68.8202 }
    },
    {
      id: 'bermejo',
      name: 'Bermejo',
      department: 'guaymallen',
      description: '',
      highlights: [],
      photos: [],
      tags: ['residencial'],
      center: { lat: -32.9151, lng: -68.7964 }
    }
  ],

  lujan_de_cuyo: [
    {
      id: 'chacras_de_coria',
      name: 'Chacras de Coria',
      department: 'lujan_de_cuyo',
      description: '',
      highlights: [],
      photos: [],
      tags: ['verde', 'gastronomico', 'premium'],
      center: { lat: -32.9823, lng: -68.8816 }
    },
    {
      id: 'vistalba',
      name: 'Vistalba',
      department: 'lujan_de_cuyo',
      description: '',
      highlights: [],
      photos: [],
      tags: ['tranquilo', 'residencial'],
      center: { lat: -32.9867, lng: -68.9221 }
    },
    {
      id: 'carrodilla',
      name: 'Carrodilla',
      department: 'lujan_de_cuyo',
      description: '',
      highlights: [],
      photos: [],
      tags: ['familiar'],
      center: { lat: -32.9602, lng: -68.8724 }
    }
  ]
};
